import React, {useState} from "react";
import {PageHeader} from "../../../../components/PageHeader";
import {toKSTISOString, toKSTISOStringEnd} from "../../../../components/commonmethod/CommonMethod";
import {addYears} from "date-fns";
import useRequestData from "../../../../hooks/useRequestData";
import {getSlaMonthList} from "../../../../api/evaluation/SlaService";
import {SlaReportListType} from "./subPages/SlaReportListType";
import {SLA_REPORT_LIST_PAGE_INDICATOR, SLA_REPORT_LIST_PAGE_TITLE} from "./slaReportUtils";

function SlaReportList() {
    const [checked, setChecked] = useState([]);
    const initDate = {
        startDate: toKSTISOString(addYears(new Date(), -1)),
        endDate: toKSTISOStringEnd(addYears(new Date(), 0)),
    };

    const {newData, pageInfo, dataHook} = useRequestData(getSlaMonthList, initDate, "sla_report");

    return (
        <div className="common-container container-height-full">
            <PageHeader
                header={SLA_REPORT_LIST_PAGE_TITLE}
                indicator={SLA_REPORT_LIST_PAGE_INDICATOR}
            />
            <SlaReportListType
                data={newData}
                date={initDate}
                pageInfo={pageInfo}
                dataHook={dataHook}
                checked={{checked, setChecked}}
            />
        </div>
    );
}

export {SlaReportList};
